import { render, staticRenderFns } from "./Autorizaciones.vue?vue&type=template&id=84301056&"
import script from "./Autorizaciones.vue?vue&type=script&lang=js&"
export * from "./Autorizaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports